import React from 'react';

const ServicesPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-[var(--brand-heading)] mb-6" style={{ fontFamily: "'Fairplay Display', Georgia, serif" }}>
        Our Services & Pricing
      </h1>
      <p className="text-lg text-slate-600 mb-12">
        Chrysalinks Group empowers lifestyle entrepreneurs with professional digital presence and business growth tools.
      </p>

      {/* Free 1-Pager Website */}
      <div className="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-slate-100">
        <div className="flex items-start gap-4">
          <div className="w-14 h-14 bg-[#4a6580]/10 rounded-xl flex items-center justify-center flex-shrink-0">
            <span className="text-2xl">🌐</span>
          </div>
          <div className="flex-1">
            <div className="flex items-center justify-between mb-2">
              <h2 className="text-2xl font-bold text-slate-800">1-Pager Website</h2>
              <span className="text-lg font-bold text-green-600">FREE</span>
            </div>
            <p className="text-slate-600 mb-4">
              Professional single-page business website with your branding, services, contact info, and social links.
              Built mobile-first and deployed to your own domain.
            </p>
            <ul className="space-y-2 text-sm text-slate-600">
              <li className="flex items-center gap-2">✅ Custom design matching your brand</li>
              <li className="flex items-center gap-2">✅ Mobile-optimised, SEO-friendly</li>
              <li className="flex items-center gap-2">✅ Hosted on your own domain</li>
              <li className="flex items-center gap-2">✅ Worth <strong>R3,997</strong> — yours free by referring 5 friends</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Network Membership */}
      <div className="bg-white rounded-2xl shadow-lg p-8 mb-8 border border-slate-100">
        <div className="flex items-start gap-4">
          <div className="w-14 h-14 bg-[#6e5c25]/10 rounded-xl flex items-center justify-center flex-shrink-0">
            <span className="text-2xl">🚀</span>
          </div>
          <div className="flex-1">
            <div className="flex items-center justify-between mb-2">
              <h2 className="text-2xl font-bold text-slate-800">Network Membership</h2>
              <span className="text-lg font-bold text-[#6e5c25]">R197/mo</span>
            </div>
            <p className="text-slate-600 mb-4">
              Unlock the full BizBuilder Platform: CRM, automation, business tools, and ongoing support.
            </p>
            <ul className="space-y-2 text-sm text-slate-600">
              <li className="flex items-center gap-2">✅ Full PWA access with all modules</li>
              <li className="flex items-center gap-2">✅ CJMS customer journey management</li>
              <li className="flex items-center gap-2">✅ Automated outreach & follow-ups</li>
              <li className="flex items-center gap-2">✅ Business performance dashboards</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Service Delivery Partner */}
      <div className="bg-white rounded-2xl shadow-lg p-8 border border-slate-100">
        <div className="flex items-start gap-4">
          <div className="w-14 h-14 bg-[#b89b2e]/10 rounded-xl flex items-center justify-center flex-shrink-0">
            <span className="text-2xl">🤝</span>
          </div>
          <div className="flex-1">
            <div className="flex items-center justify-between mb-2">
              <h2 className="text-2xl font-bold text-slate-800">Service Delivery Partner</h2>
              <span className="text-lg font-bold text-[#b89b2e]">80% Commission</span>
            </div>
            <p className="text-slate-600 mb-4">
              Become a certified delivery partner and earn 80% commission on every website you build and deploy.
            </p>
            <ul className="space-y-2 text-sm text-slate-600">
              <li className="flex items-center gap-2">✅ 80% commission per project</li>
              <li className="flex items-center gap-2">✅ Training & certification included</li>
              <li className="flex items-center gap-2">✅ White-label delivery platform</li>
              <li className="flex items-center gap-2">✅ Build on your own schedule</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
